import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  FormControl, InputLabel, FormLabel,
  InputAdornment,
  IconButton, styled,
  InputBase,
  Select,
  MenuItem, Backdrop,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import checkImg from "../../assets/images/Checking-and-Routing-Numbers.png";
import info from "../../assets/images/shopaccordion/comm-pre-tooltip.svg";
import { v4 as uuidv4 } from "uuid";
import { addEneventGTM, AddUpdatePaymentGTM, sendEventGTMLog } from "../../Utils/googleTags";
import ApiUrls from "../../Utils/axr";
import { useAppSelector, useAppDispatch } from "../../hooks";

import VisibilityIcon from "../../assets/icon-view-on.png";
import VisibilityOffIcon from "../../assets/icon-view-off.png";
import close from "../../assets/icon-close.svg";
import "./index.css";
import ToastCustonIcon from "../../SharedComponents/toastCustomIcons";

import DwLogutil from "../../Utils/DwLogutil";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import useBrightspeedHeaders from "../../hooks/useBrightspeedHeader";

// submitAutoPaymentMethod
import {
  submitAutoPaymentMethod,
  updatePaymentMethod,
} from "../../../../shared/hooks/useFetchPayment";

/* Add card icon Images */
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { getquickBillPayPageContent } from "../../SharedContextStore/slices/contents/qbpContentAem";
import { getCardNumberWithMasking } from "../../Utils/utils";
import { EligiblePaymentOverall, QuickBillPay } from "../../SharedComponents/contents";
import useBrightspeedUser from "../../hooks/useUser";
import { sendEventLog } from "../../Utils/app-log";
import { setaddPaymentMethodError } from "../../SharedContextStore/slices/paymentMethods";

type SelectedCardType = "Credit Card" | "Paypal" | "Apple pay" | "Bank Account";

interface addNewPaymentMethod {
  onClose: () => void;
  onAddEditSuccess: () => void;
  card?: {
    fullName: string;
    creditCardNumber: string | null;
    expiryDate: string;
    cvv: string;
    streetaddress: string;
    city: string;
    zipCode: string;
    state: string;
    cardId: string | null;
    creditCardType?: string | null;
  };
  bank?: {
    id: string | null;
    bankAccountType: string;
    bankAccountNumber: string;
    routingNumber: string;
    confirmBankAccountNumber?: string;
    accountUserName?: string;
    isTermsAndCondition: boolean;
  };
  QBP_ON?: boolean;
  isAutoPay?: boolean;
  unAuthQbp?: boolean;
  isPrimaryPaymentMethod?: boolean;
  isUnAuthPa?: boolean;
  showTC?: boolean;
}

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    color: "rgba(0, 0, 0, 0.87)",
    //   boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    position: "relative",
    // border: "solid 1px #000",
    backgroundColor: "#fff",
    fontSize: 16,
    width: "100%",
    padding: "8px 16px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      borderColor: "#000",
    },
  },
}));

const BootstrapSelect = styled(Select)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    position: "relative",
    // border: "solid 1px #000",
    backgroundColor: "#fff",
    fontSize: 16,
    width: "100%",
    padding: "8px 6px 8px 10px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      borderColor: "#000",
    },
  },
}));

const inputLabelCss = {
  color: "#000",
  fontSize: "16px",
  fontWeight: 400,
  "&.Mui-focused": {
    color: "#000",
  },
  gap: "8px",
  top: "-3px",
};

const AddPaymentMethodBank = (props: any) => {
  const {
    unAuthQbp,
    onClose,
    onAddEditSuccess,
    card,
    bank,
    QBP_ON,
    isAutoPay,
    showApifailPopup,
    fromEditCard,
    isUnAuthPa,
    showTC = false,
  } = props;
  const eligiblePaymentOverall: any = EligiblePaymentOverall();
  const JSONcontent: any = eligiblePaymentOverall?.entry;
  const headers = useBrightspeedHeaders();
  const quickBillPayPageContent: any = useAppSelector(
    (state) => state?.quickBillPayContent?.quickBillPayPageContent
  );
  const quickBillPay: any = QuickBillPay();
  const QBP_CONTENT_2: any = quickBillPay?.entry;
  const { accountType } = useBrightspeedUser();
  const PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION =
    QBP_CONTENT_2?.paymentMethodSection?.addPaymentMethodSection?.credit_card_details;
  const PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION =
    QBP_CONTENT_2?.paymentMethodSection?.editPaymentMethodSection?.credit_card_details;
  const PAYMENT_METHOD_CREDIT_MANAGE_AUTOPAY_SECTION = QBP_CONTENT_2?.paymentMethodSection?.addBankAccount?.manageautopay;
  const PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION = QBP_CONTENT_2?.paymentMethodSection?.addBankAccount?.bank_account_details;
  const QBP_FLOW_SELECT_PAYMENT = QBP_CONTENT_2?.qbp_flow?.select_payment_method;
  const QBP_FLOW = QBP_CONTENT_2?.qbp_flow;
  const { isPostPaidFiberUser } = useBrightspeedUser();
  const { isAutoPayEnrolled } = useAppSelector((state) => state?.planDetails);
  const autoPayEnrolled: boolean = isAutoPayEnrolled;

  
  const showTooltip = (id: string, show: boolean) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (show) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
  };


  const getBankValidationSchema = (
    fromEditCard: boolean,
    QBP_ON: boolean,
    isAutoPay: boolean,
    showTC: boolean
  ) => {
    const bankAccountNumberRegesSchema = yup
      .string()
      .required(
        `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.accountTypeError}.`
      )
      // .matches(/^[0-9A-Za-z]{17}$/, "Invalid Bank acount number. Make sure it is length of 17.")
      //.max(10, "Bank account number must be less than 10 digits")
      //.equals([10], "Bank account number must be equal to 10 digits")
      //.test("bankAccount", "Invalid Bank account number", validateBankAccount)
      .nullable();

    // const bankAccountNumberWithoutRegesSchema = yup
    //   .string()
    //   .required("Please enter your bank account number.")
    //   .nullable();

    const termsConditionSchema = //Work only for Non QBP scenarios
      (!showTC)
        ? yup.boolean().notRequired()
        : yup
          .boolean()
          .required(
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.paymentTermsAndConditionError}`
          )
          .oneOf(
            [true],
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.paymentTermsAndConditionError}`
          )
          .default(false);

    const addBankSchema = yup
      .object({
        bankAccountType: yup
          .mixed()
          .oneOf(
            ["Checking", "Savings"],
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.selectAccountTypeError}.`
          ),
        accountUserName: yup
          .string()
          .required(
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.accountHolderNameMissingError}.`
          )
          .nullable(),
        bankAccountNumber: bankAccountNumberRegesSchema,
        // bankAccountNumber: fromEditCard ? bankAccountNumberWithoutRegesSchema : bankAccountNumberRegesSchema,
        routingNumber: yup
          .string()
          .required(
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.routingNumberMissingError} \n\n • ${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.routingNumberMissingErrorDesc1} \n • ${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.routingNumberMissingErrorDesc2}.`
          )
          // .test(
          //     'routingNumber',
          //     'The number must be equal to 9 digits',
          //     (value:any) => value.length == 9
          //   )
          //.matches(/^(0|1|2|3)/, "Router numbers start with 0, 1, 2. or 3.")
          //.matches(/\d{9}/, "Router numbers are 9 digits.")

          .matches(
            /^(0|1|2|3)/,
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.validBankNumber} \n\n  • ${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.routingNumberMissingErrorDesc1} \n  • ${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.routingNumberMissingErrorDesc2}.`
          )
          .matches(
            /\d{9}/,
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.validBankNumber} \n\n  • ${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.routingNumberMissingErrorDesc1} \n  • ${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.routingNumberMissingErrorDesc2}.`
          )
          .nullable(),
        confirmBankAccountNumber: yup
          .string()
          .required(
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.accountTypeError}.`
          )
          // .mixed()
          .oneOf(
            [yup.ref("bankAccountNumber")],
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.accountNumberNotPresentError}`
          )
          .nullable(),

        isTermsAndCondition: termsConditionSchema,
      })
      .required();

    return addBankSchema;
  };

  const addBankSchema = getBankValidationSchema(
    fromEditCard,
    QBP_ON,
    isAutoPay,
    showTC,
  );

  useEffect(() => {
    if (!quickBillPayPageContent) {
      dispatch(getquickBillPayPageContent());
    }
  }, []);

  const companyName: any = useAppSelector((state) => state.user.companyName);
  const user = useAppSelector((state) => state.user.data);
  // const userCompanyName = useAppSelector((state) => state?.user?.companyName);
  const sessionId = useAppSelector((state) => state?.user?.sessionId);
  const { defaultPaymentMethodId } = useAppSelector(
    (state) => state.paymentMethods.paymentMethods || {}
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [showRouting, setShowRouting] = useState(false);
  const [showBankAccountConfirm, setShowBankAccountConfirm] = useState(false);
  const [showBankAccount, setShowBankAccount] = useState(false);
  const [isSubmitLoader, setIsSubmitLoader] = useState(false);
  const [isEditFormTidy, setIsEditFormTidy] = useState<any>(null);
  const [isUnAUthQbpFormTidy, setIsUnAUthQbpFormTidy] = useState<boolean>(
    unAuthQbp ? true : false
  );
  const [isUnAUthPaFormTidy, setIsUnAUthPaFormTidy] = useState<boolean>(
    isUnAuthPa ? true : false
  );
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const userBillingAddress = user?.addresses
    ? user?.addresses.filter(
      (address: any) => address.addressType === "BillingAddress"
    )[0]
    : {};

  const {
    qbp_cancel_form,
    qbp_add_bank_method_successs,
    qbp_add_bank_method_failed,
    qbp_update_bank_method_success,
    qbp_update_bank_method_failed,
    qbp_update_bank_method_attempted,
    unauthqbp_cancel_step1,
    unauthqbp_add_bank_method_success,
    unauthqbp_add_bank_method_failed,
    Pa_edit_bank_payment_method_success,
    Pa_edit_bank_payment_method_failure,
    Pa_add_bank_payment_method_failure,
    Pa_add_bank_payment_method_success,
    AP_edit_PM_bank_sucess,
    AP_edit_PM_bank_failed,
    AP_add_PM_bank_cancel_cta,
    AP_add_PM_bank_continue_cta,
    AP_add_PM_bank_sucess,
    AP_add_PM_bank_failed,
    AP_edit_PM_bank_cancel_cta,
    AP_edit_PM_bank_continue_cta,
    unauthqbp_add_bank_method_attempted,
    qbp_add_bank_payment_method_attempted,
    unauthqbp_update_bank_method_attempted,
    unauthqbp_update_bank_method_success,
    unauthqbp_update_bank_method_failed,
  } = EC_DW_LOGGING_STEPS

  const dwLogDefaults = {
    headers,
    sessionId,
    email: user?.email,
    companyName: companyName,
  }

  const {
    register: registerCreditCardCtlUser,
    handleSubmit: handleSubmitCreditCardCtl,
    setValue: setValueForCtlUser,
    watch,
    formState: { errors, isValid, isDirty },
    reset,
    trigger,
  } = useForm({
    mode: "onTouched",
    defaultValues: {
      creditCardNumber:
        (card?.creditCardNumber &&
          getCardNumberWithMasking(card?.creditCardNumber)) ||
        null,
      fullName: card?.fullName || null,
      expirationDate: card?.expiryDate || null,
      cvv: card?.cvv || null,
      isPrimaryPaymentMethod: card?.cardId === defaultPaymentMethodId || false,
      isSameAsServiceAddress: false,
      streetaddress: card?.streetaddress || "",
      city: card?.city || null,
      zipCode: card?.zipCode || null,
      state: card?.state || "State",
    },
  });

  const {
    register: registerBankAccount,
    handleSubmit: handleSubmitBankAccount,
    setValue: setValueForBank,
    watch: watchBank,
    formState: {
      errors: errorsBankAccountDetails,
      isValid: isBankValid,
      isDirty: isBankDetailsDirty,
    },
    reset: resetBankDetails,
    trigger: triggerBankDetails,
  } = useForm({
    resolver: yupResolver(addBankSchema),
    mode: "onTouched",
    defaultValues: {
      bankAccountType: props.retainformData?.bankAccountType || bank?.bankAccountType || "selectAccountType",
      bankAccountNumber: props.retainformData?.bankAccountNumber || bank?.bankAccountNumber || null,
      routingNumber: props.retainformData?.routingNumber || bank?.routingNumber || null,
      confirmBankAccountNumber: props.retainformData?.bankAccountNumber || bank?.bankAccountNumber || null,
      isPrimaryPaymentMethod: props.retainformData?.isPrimaryPaymentMethod || bank?.isPrimaryPaymentMethod || false,
      accountUserName: props.retainformData?.accountUserName || bank?.accountUserName || null,
      isTermsAndCondition: props.retainformData?.accountUserName || false
    },
  });

  useEffect(() => {
    if (fromEditCard) {
      setShowBankAccount(true)
      setShowBankAccountConfirm(true);
    }

    if(!defaultPaymentMethodId){
      setValueForBank("isPrimaryPaymentMethod", true);
    }

  }, [bank])

  // To check Edit Form is Tidy - Enables Continue button
  useEffect(() => {
    if (fromEditCard) {
      if (!isEditFormTidy) setIsEditFormTidy(true);

      if (
        !watchBank("bankAccountNumber")?.includes("*") ||
        !watchBank("confirmBankAccountNumber")?.includes("*")
      ) {
        setIsEditFormTidy(false);
      }

    }

    if (isUnAuthPa && !fromEditCard) {
      const accountType = watchBank("bankAccountType");
      const userName = watchBank("accountUserName");
      const routingNumber = watchBank("routingNumber");
      const bankAccountNumber = watchBank("bankAccountNumber");
      const confirmBankAccountNumber = watchBank("confirmBankAccountNumber");

      if (
        accountType !== "selectAccountType" &&
        !(userName === null || userName === "") &&
        !(routingNumber === null || routingNumber === "") &&
        !(bankAccountNumber === null || bankAccountNumber === "") &&
        !(confirmBankAccountNumber === null || confirmBankAccountNumber === "")
      ) {
        setIsUnAUthPaFormTidy(false);
      } else {
        setIsUnAUthPaFormTidy(true);
      }
    }

    if (isUnAuthPa && fromEditCard) {
      const accountType = watchBank("bankAccountType");
      const userName = watchBank("accountUserName");
      const routingNumber = watchBank("routingNumber");
      const bankAccountNumber = watchBank("bankAccountNumber");
      const confirmBankAccountNumber = watchBank("confirmBankAccountNumber");

      if (
        accountType !== "selectAccountType" &&
        (userName !== null && userName !== "") &&
        (routingNumber !== null && routingNumber !== "") &&
        (bankAccountNumber !== null && bankAccountNumber !== "") &&
        (confirmBankAccountNumber !== null && confirmBankAccountNumber !== "") &&
        !watchBank("bankAccountNumber")?.includes("*") &&
        !watchBank("confirmBankAccountNumber")?.includes("*")
      ) {
        setIsUnAUthPaFormTidy(false);
      } else {
        setIsUnAUthPaFormTidy(true);
      }
    }

    if (
      unAuthQbp &&
      watchBank("bankAccountType") !== "selectAccountType" &&
      watchBank("accountUserName") !== null &&
      watchBank("routingNumber") !== null &&
      watchBank("bankAccountNumber") !== null &&
      watchBank("confirmBankAccountNumber") !== null
      // watchBank("isTermsAndCondition")
    ) {
      setIsUnAUthQbpFormTidy(false);
    }
  }, [
    watchBank("bankAccountType"),
    watchBank("accountUserName"),
    watchBank("routingNumber"),
    watchBank("bankAccountNumber"),
    watchBank("confirmBankAccountNumber"),
    // watchBank("isTermsAndCondition"),
  ]);

  /* const companyCtl =
    companyName &&
    ["CTL", "CENTURY LINK"]?.includes(companyName?.toUpperCase());
 */
  const clearForm = (isAccountType: boolean, accountType: any) => {
    addEneventGTM(
      (isAccountType) ? "EC_Payment_method_account_type_change" : "EC_Payment_method_clearall_link_click",
      sessionId,
      user?.billingAccountNumber,
      companyName
    );
    setValueForBank("bankAccountType", isAccountType ? accountType : "selectAccountType");

    if (fromEditCard && accountType === bank?.bankAccountType) {
      resetBankDetails({
        bankAccountType: bank?.bankAccountType,
        bankAccountNumber: bank?.bankAccountNumber,
        routingNumber: bank?.routingNumber,
        confirmBankAccountNumber: bank?.bankAccountNumber,
        isPrimaryPaymentMethod: (defaultPaymentMethodId === bank?.id) || !defaultPaymentMethodId ? true : false,
        accountUserName: bank?.accountUserName,
        isTermsAndCondition: false,
      });
    } else {
      resetBankDetails({
        bankAccountType: isAccountType ? accountType : "selectAccountType",
        bankAccountNumber: null,
        routingNumber: null,
        confirmBankAccountNumber: null,
        isPrimaryPaymentMethod: ((defaultPaymentMethodId === bank?.id) || !defaultPaymentMethodId) ? true : false,
        accountUserName: null,
        isTermsAndCondition: false,
      });
    }
  };

  const onSubmitBankDetails = async (data: any) => {
    /** Method to Sumit both Add & Edit Bank Form */
    const siteId = localStorage?.getItem("headersSiteId") || headers?.siteId;
    if (isAutoPay) {
      (fromEditCard)
        ? DwLogutil({ ...dwLogDefaults, stepName: AP_edit_PM_bank_continue_cta })
        : DwLogutil({ ...dwLogDefaults, stepName: AP_add_PM_bank_continue_cta });
    }

    const successStepName =
      fromEditCard
        ? isUnAuthPa
          ? Pa_edit_bank_payment_method_success
          : unAuthQbp
            ? unauthqbp_update_bank_method_success
            : isAutoPay
              ? AP_edit_PM_bank_sucess
              : qbp_update_bank_method_success
        : isUnAuthPa
          ? Pa_add_bank_payment_method_success
          : unAuthQbp
            ? unauthqbp_add_bank_method_success
            : isAutoPay
              ? AP_add_PM_bank_sucess
              : qbp_add_bank_method_successs;

    const failStepName =
      fromEditCard
        ? isUnAuthPa
          ? Pa_edit_bank_payment_method_failure
          : unAuthQbp
            ? unauthqbp_update_bank_method_failed
            : (isAutoPay) ? AP_edit_PM_bank_failed : qbp_update_bank_method_failed
        : isUnAuthPa
          ? Pa_add_bank_payment_method_failure
          : unAuthQbp
            ? unauthqbp_add_bank_method_failed
            : (isAutoPay) ? AP_add_PM_bank_failed : qbp_add_bank_method_failed;

    const consolidatedFormData = {
      bankAccountType: data?.bankAccountType,
      accountUserName: data?.accountUserName,
      routingNumber: data?.routingNumber,
      bankAccountNumber: data?.bankAccountNumber,
      confirmBankAccountNumber: data?.bankAccountNumber,
      isTermsAndCondition: true,
      type: data?.bankAccountType,
      paymentType: "ACH",
      accountHolderInfo: {
        accountHolderName: data?.accountUserName,
        zipCode: userBillingAddress?.zip,
      },
    };

    /** For Non auth flow, when user goes back and submits same form data */
    if (unAuthQbp) {
      const { routingNumber, bankAccountNumber, retainPaymentAuthId } = props?.retainformData
      if (unAuthQbp && routingNumber === data?.routingNumber && bankAccountNumber === data?.bankAccountNumber) {
        props.unAuthCardInfo({
          id: retainPaymentAuthId,
          ...consolidatedFormData
        });

        // props.retainformDataOnRevisit ({
        //   retainPaymentAuthId,
        //   ...consolidatedFormData
        // });

        DwLogutil({
          ...dwLogDefaults,
          stepName: successStepName
        });
        sendEventLog(successStepName, {
          successStepName: successStepName
        });
        sendEventGTMLog(successStepName,companyName || headers?.siteId)
        addEneventGTM(
          successStepName,
          sessionId,
          user?.billingAccountNumber,
          companyName
        );

        return onAddEditSuccess();
      }
    }

    const REQUEST_API = fromEditCard
      ? {
        [ApiUrls.updatePaymentMethodUrl_QA]: `${bank?.id}?ban=${user?.billingAccountNumber}`,
      }
      : unAuthQbp
        ? { "": [ApiUrls.purlPaymentAuthId] }
        : { "": [ApiUrls.addAutoPaymentMethodUrl_QA] };

    const REQUEST_BODY = fromEditCard
      ? {
        baseline: { siteId },
        cardHolderName: data?.accountUserName,
        kind: "ACH",
        banNumber: user?.billingAccountNumber,
        paymentMethodKind: data?.bankAccountType,
        routingNumber: data?.routingNumber,
        bankAccountNumber: data?.bankAccountNumber,
        defaultPaymentMethod: isAutoPay ? data?.isPrimaryPaymentMethod : false,
        email: user?.email,
      }
      : {
        baseline: {
          siteId,
          billingType: user?.billingType,
          transactionId: uuidv4(),
          channel: "web-acm",
        },
        street: userBillingAddress?.street,
        city: userBillingAddress?.city,
        state: userBillingAddress?.state,
        zip: userBillingAddress?.zip,
        cardHolderName: data?.accountUserName,
        paymentType: "ACH",
        creditAccount: user?.billingAccountNumber,
        paymentMethodKind: data?.bankAccountType,
        rountingNumber: data?.routingNumber,
        bankAccountNumber: data?.bankAccountNumber,
        defaultPaymentMethod: isAutoPay ? data?.isPrimaryPaymentMethod : false,
        email: user?.email,
        classValue: ""
      };

    const customToastMsg = fromEditCard
      ? PAYMENT_METHOD_CREDIT_MANAGE_AUTOPAY_SECTION?.success_payment_method
      : PAYMENT_METHOD_CREDIT_MANAGE_AUTOPAY_SECTION?.success_add_bank

    setIsSubmitLoader(true);
    try {
      if (unAuthQbp) {
        if (fromEditCard) {
          DwLogutil({ stepName: unauthqbp_update_bank_method_attempted });
          sendEventLog(unauthqbp_update_bank_method_attempted, {
            unauthqbp_update_bank_method_attempted: unauthqbp_update_bank_method_attempted
          });
          sendEventGTMLog(unauthqbp_update_bank_method_attempted,companyName || headers?.siteId)
        } else {
          DwLogutil({ stepName: unauthqbp_add_bank_method_attempted });
          sendEventLog(unauthqbp_add_bank_method_attempted, {
            unauthqbp_add_bank_method_attempted: unauthqbp_add_bank_method_attempted
          });
          sendEventGTMLog(unauthqbp_add_bank_method_attempted,companyName || headers?.siteId)
        }
      } else {
        if (fromEditCard) {
          DwLogutil({ stepName: qbp_update_bank_method_attempted });
          sendEventLog(qbp_update_bank_method_attempted, {
            qbp_update_bank_method_attempted: qbp_update_bank_method_attempted
          });
          sendEventGTMLog(qbp_update_bank_method_attempted,companyName || headers?.siteId)
        } else {
          DwLogutil({ stepName: qbp_add_bank_payment_method_attempted });
          sendEventLog(qbp_add_bank_payment_method_attempted, {
            qbp_add_bank_payment_method_attempted: qbp_add_bank_payment_method_attempted
          });
          sendEventGTMLog(qbp_add_bank_payment_method_attempted,companyName || headers?.siteId)
        }
      }

      /* Add Paymant */
      const response = fromEditCard
        ? await updatePaymentMethod(REQUEST_API, REQUEST_BODY, headers)
        : await submitAutoPaymentMethod(REQUEST_API, REQUEST_BODY, headers);

      /** Unauth QBP - data object, set as Prop for Verify & Confirm page  */
      if (unAuthQbp) {
        if (response?.data?.paymentAuthId) {
          props.unAuthCardInfo({
            id: response?.data?.paymentAuthId,
            ...consolidatedFormData
          });

          // props.retainformDataOnRevisit ({
          //   retainPaymentAuthId: response?.data?.paymentAuthId,
          //   ...consolidatedFormData
          // });
          toast.success(customToastMsg, {
            icon: <ToastCustonIcon type="success" />,
          });
          onAddEditSuccess();
          DwLogutil({
            ...dwLogDefaults,
            stepName: successStepName
          });
          sendEventLog(successStepName, {
            successStepName: successStepName
          });
          sendEventGTMLog(successStepName,companyName || headers?.siteId)
          addEneventGTM(
            successStepName,
            sessionId,
            user?.billingAccountNumber,
            companyName
          );
          AddUpdatePaymentGTM(fromEditCard ? "update_bank_payment_info_success" : "add_bank_payment_info_success", companyName || headers?.siteId, "", accountType, user?.billingAccountNumber)
          clearForm(true, "clear")
          onClose();
        }
        else {
          DwLogutil({
            ...dwLogDefaults,
            stepName: failStepName,
            error: response?.data?.paymentResponse?.message || 'Api error'
          });
          sendEventLog(failStepName, {
            failStepName: failStepName
          });
          sendEventGTMLog(failStepName,companyName || headers?.siteId)
          addEneventGTM(
            failStepName,
            sessionId,
            user?.billingAccountNumber,
            companyName
          );
          AddUpdatePaymentGTM(fromEditCard ? "update_bank_payment_info_failed" : "add_bank_payment_info_failed", companyName || headers?.siteId, response?.data?.paymentResponse?.message || 'bank payment method failed Api error from catch block', accountType, user?.billingAccountNumber)
          onClose();
          showApifailPopup();
        }
        return true;
      }

      if (response) {
        setIsSubmitLoader(false);
        onAddEditSuccess();
        if(!autoPayEnrolled){
        toast.success(customToastMsg, {
          icon: <ToastCustonIcon type="success" />,
        });
        }

        DwLogutil({
          ...dwLogDefaults,
          stepName: successStepName
        });
        sendEventLog(successStepName, {
          successStepName: successStepName
        });
        sendEventGTMLog(successStepName,companyName || headers?.siteId)
        addEneventGTM(
          successStepName,
          sessionId,
          user?.billingAccountNumber,
          companyName
        );
        AddUpdatePaymentGTM(fromEditCard ? "update_bank_payment_info_success" : "add_bank_payment_info_success", companyName || headers?.siteId, "", accountType, user?.billingAccountNumber)
        clearForm(true, "clear")
        onClose();
      }
    }
    catch (error: any) {
      console.error(error);
      setIsSubmitLoader(false);
      dispatch(setaddPaymentMethodError(error?.response?.data?.exception));
      DwLogutil({
        ...dwLogDefaults,
        stepName: failStepName,
        error: error?.message || 'Api error'
      });
      sendEventLog(failStepName, {
        failStepName: failStepName
      });
      sendEventGTMLog(failStepName,companyName || headers?.siteId)
      addEneventGTM(
        failStepName,
        sessionId,
        user?.billingAccountNumber,
        companyName
      );
      AddUpdatePaymentGTM(fromEditCard ? "update_bank_payment_info_failed" : "add_bank_payment_info_failed", companyName || headers?.siteId, error?.message || 'bank payment method failed Api error from catch block', accountType, user?.billingAccountNumber)

      !unAuthQbp && onClose();
      showApifailPopup();

      if (unAuthQbp) {
        clearForm(false, "clear")
        // props.retainformDataOnRevisit ({
        //   bankAccountType: 'selectAccountType',
        //   accountUserName: null,
        //   routingNumber: null,
        //   bankAccountNumber: null,
        //   confirmBankAccountNumber: null,
        //   isTermsAndCondition: false
        // });
      }
    }
  };


  const selectAccountTypeStyle = `${watchBank("bankAccountType") === "selectAccountType" ? "default-value" : ""
    } ${errorsBankAccountDetails?.bankAccountType
      ? "inputErrorBorder"
      : "inputNormalBorder"
    }`;

  const Step2of3_JSON = JSONcontent?.step2Of3;
  return (
    <Box className={`addNewPaymentMethod ${unAuthQbp ? "unauth-qbp" : ""} addNewPaymentMethodAutopay`}>

      {!unAuthQbp && (
        <Box id="scroll-dialog-title" 
          className="paymentMethodHeading"
          sx={{
            marginTop: "0",
          }}
        >
          <Typography className="prePayTitle" component="h2" id="clear"
            sx={{
              fontSize: "19px",
              fontWeight: "bold",
            }}
          >
            {fromEditCard
              ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.title
              : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.title}
          </Typography>
          <Typography aria-describedby="clear"
            sx={{
              fontSize: "14px",
              cursor: "pointer",
            }}
            className="clearLabel modelButton"
            onClick={() => { clearForm(false, "clear") }}
            component="button"
          >
            <u>{PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.clearAllLabel}</u>
          </Typography>
        </Box>
      )}

      {!unAuthQbp && <Divider role="presentation" />}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          mx: { sm: 0, md: 0 },
        }}
      >
        {/* {companyCtl && (
          <> */}
        <Box className={`mainFields ${unAuthQbp ? 'unAuthfield' : ''}`} sx={{ width: { xs: "100%", sm: "460px" } }}
        //  id="scroll-dialog-description"
        >
          <Typography component="h3"
            className="creditCardLabel font-primary text-color-primary"
            id="scroll-dialog-title"
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              mt: 2,
            }}
          >
            {PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.bankAccountInfoLabel}
          </Typography>
          
          <FormControl
            component="fieldset"
            className="bankAccountInput"
            variant="standard"
            sx={{ width: "100%", my: 1 }}
          >
            {/* Legend becomes the group label read by SRs */}
            <FormLabel
              component="legend"
              sx={inputLabelCss}
              id="bankAccountType-legend"
            >
              {PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.bankAccountTypeLabel}
              {/* Indicate required visually and programmatically */}
              {/* <span aria-hidden="true" className="required-asterisk">*</span> */}
            </FormLabel>

            {/* Associate the legend with the group and expose required state */}
            <RadioGroup
              className="bank-type-radio-button"
              row
              //aria-labelledby="bankAccountType-legend"
              
              aria-describedby="bankAccountType-error"
              aria-invalid={Boolean(errorsBankAccountDetails?.bankAccountType) || undefined}
              //aria-required="true"
              id="bankAccountType"
              value={watchBank("bankAccountType")}
              onChange={(e: any) => {
                setValueForBank("bankAccountType", e.target.value);
                clearForm(true, e.target.value);
              }}
            >
              <FormControlLabel
                value="Checking"
                control={<Radio {...registerBankAccount("bankAccountType", { required: "Please select your account type." })}/>}
                label="Checking"
              />
              <FormControlLabel
                value="Savings"
                control={<Radio {...registerBankAccount("bankAccountType", { required: "Please select your account type." })}/>}
                label="Savings"
              />
            </RadioGroup>

            {/* Error message container with live region and id used by aria-describedby */}
            <Box
              className="errorMsgFormat"
              id="bankAccountType-error"
              aria-live="polite"
            >
              <ErrorMessage
                errors={errorsBankAccountDetails}
                name="bankAccountType"
                render={({ message }) => (
                  <>
                    <span className="inputFiledErrorImg" />
                    <span className="inputFiledErrorMsg">{message}</span>
                  </>
                )}
              />
            </Box>
          </FormControl>
          <FormControl
            className="bankAccNameInput"
            variant="standard"
            sx={{ width: "100%", my: 1 }}
          >
            <InputLabel sx={inputLabelCss} shrink htmlFor="accountUserName">
              {PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.accountHolderNameLabel}
            </InputLabel>
            <BootstrapInput
              defaultValue=""
              id="accountUserName"
              aria-describedby="accholder-error"
              {...registerBankAccount("accountUserName")}
              placeholder={PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.accountHolderNamePlaceholder}
              type={"text"}
              autoComplete="new-password"
              className={
                errorsBankAccountDetails?.accountUserName
                  ? "inputErrorBorder"
                  : ""
              }
              onKeyPress={(e: any) => {
                if (!e.target.value && e.key === ' ') {//Prevents First space charac
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                setValueForBank("accountUserName", e.target.value.trimStart());
              }}
              inputProps={{
                "aria-invalid":
                  errors && Object.keys(errors).includes("accountUserName") ? "true" : "false",
                "aria-required": true,
              }}
            />
            <ErrorMessage
              errors={errorsBankAccountDetails}
              name="accountUserName"
              render={({ message }) => (
                <Box className="errorMsgFormat" id="accholder-error">
                  <span className="inputFiledErrorImg"></span>
                  <span className="inputFiledErrorMsg">{message}</span>
                </Box>
              )}
            />
          </FormControl>

          <FormControl
            className="creditCardInput"
            variant="standard"
            sx={{ width: "100%", my: 1 }}
          >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <InputLabel sx={inputLabelCss} shrink htmlFor="routingNumber">
              {PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.accountRoutingNoLabel}
            </InputLabel>

            {/* SR tip content (hidden until the icon is focused/hovered) */}
            <div
              id="routing-tip"
              role="tooltip"
              aria-live="polite"
              aria-hidden="true"
              style={{ display: "none" }}
            >
              {Step2of3_JSON?.accountNumberAlert}
            </div>

            <LightTooltip
              title={
                <div style={{ position: "relative" }}>
                  <img
                    src={checkImg}
                    alt=""                 /* visual only; SR text in routing-tip */
                    style={{ position: "absolute", top: "-220px", left: "-120px" }}
                  />
                </div>
              }
              placement="top"
              enterTouchDelay={0}
            >
              <IconButton
                className="infobtn"
                tabIndex={0}
                aria-label="Routing number tooltip"
                role="button"
                aria-describedby="routing-tip"
                onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      showTooltip('account-tip', false)
                      e.currentTarget.blur();
                    }
                  }}
                onFocus={() => showTooltip('routing-tip', true)}
                onBlur={() => showTooltip('routing-tip', false)}
                onMouseEnter={() => showTooltip('routing-tip', true)}
                onMouseLeave={() => showTooltip('routing-tip', false)}
              >
                <img src={info} className="info-image" alt="" />
              </IconButton>
            </LightTooltip>
          </div>

            <BootstrapInput
              defaultValue=""
              id="routingNumber"
              aria-describedby="routingNumber-error"
              {...registerBankAccount("routingNumber")}
              placeholder={PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.accountRoutingNoPlaceholder}
              // type={showRouting ? "text" : "password"}
              type="text"
              inputMode="numeric"
              autoComplete="new-password"
              endAdornment={
                <InputAdornment
                  position="end"
                  className="eyeToggleBtnWrap"
                  sx={{
                    padding: "0px",
                    position: "absolute",
                  }}
                >
                  <IconButton
                    className="togglePwdVisiblebtn"
                    aria-label="routing Number"
                    // role="switch"                       
                    aria-describedby="eye-icon"
                    aria-pressed={showRouting}
                    // aria-checked={showRouting}
                    onClick={() => setShowRouting(!showRouting)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setShowRouting(!showRouting)
                      }
                    }}
                    edge="end"
                    onMouseDown={handleMouseDownPassword}
                  >

                    {!showRouting ? (
                      <span aria-label="hide routing Number" id="eye-icon"><img src={VisibilityOffIcon} alt="" /></span>
                    ) : (
                      <span aria-label="show routing Number" id="eye-icon"> <img src={VisibilityIcon} alt="" /></span>
                    )}
                  </IconButton>
                </InputAdornment>
              }
              // inputProps={{ maxLength: 9, minLength: 9 }}
              inputProps={{
                "aria-invalid":
                  errors && Object.keys(errors).includes("routingNumber") ? "true" : "false",
                "aria-required": true,
                maxLength: 9, minLength: 9,
              }}
              onKeyPress={(e: any) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
                if (e.target.value.length > "9") {
                  e.preventDefault();
                  return false;
                }
              }}
              className={
                errorsBankAccountDetails?.routingNumber
                  ? "inputErrorBorder"
                  : ""
              }
            />
            <ErrorMessage
              errors={errorsBankAccountDetails}
              name="routingNumber"
              render={({ message }) => (
                <Box className="errorMsgFormat" id="routingNumber-error" >
                  <span className="inputFiledErrorImg imageError"></span>
                  <span className="inputFiledErrorMsg">{message}</span>
                </Box>
              )}
            />
          </FormControl>

          <FormControl
            className="creditCardInput"
            variant="standard"
            sx={{ width: "100%", my: 1 }}
          >              
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <InputLabel sx={inputLabelCss} shrink htmlFor="bankAccountNumber">
                {PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.bankAccountNoLabel}
              </InputLabel>
              <div
                id="account-tip"
                role="tooltip"
                aria-live="polite"
                aria-hidden="true"
                style={{ display: "none" }}
              >
                
              {PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.bankAccountNoHelpText ?? 'Find your routing and account number for your bank account at the bottom of your checks.'}

              </div>

              <LightTooltip
                title={
                  <div style={{ position: "relative" }}>
                    <img
                      src={checkImg}
                      alt=""                 /* visual only */
                      style={{ position: "absolute", top: "-215px", left: "-120px" }}
                    />
                  </div>
                }
                placement="top"
                enterTouchDelay={0}
              >
                <IconButton
                  className="infobtn"
                  tabIndex={0}
                  aria-label="Account number tooltip"
                  aria-describedby="account-tip"
                  role="button"
                  onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      showTooltip('account-tip', false)
                      e.currentTarget.blur();
                    }
                  }}
                  onFocus={() => showTooltip('account-tip', true)}
                  onBlur={() => showTooltip('account-tip', false)}
                  onMouseEnter={() => showTooltip('account-tip', true)}
                  onMouseLeave={() => showTooltip('account-tip', false)}
                >
                  <img src={info} className="info-image" alt="" />
                </IconButton>
              </LightTooltip>
            </div>


            <BootstrapInput
              defaultValue=""
              id="bankAccountNumber"
              aria-describedby="bankAccountNumber-error"
              {...registerBankAccount("bankAccountNumber")}
              placeholder={PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.bankAccountNoPlaceholder}
              //type={showBankAccount ? "text" : "password"}
              type="text"
              inputMode="numeric"
              autoComplete="new-password"
              endAdornment={
                <InputAdornment
                  position="end"
                  className="eyeToggleBtnWrap"
                  sx={{
                    padding: "0px",
                    position: "absolute",
                  }}

                >
                  <IconButton
                    className="togglePwdVisiblebtn"
                    aria-label="account Number"
                    // role="switch"                       
                    aria-describedby="eye-toggle"
                    aria-pressed={showBankAccount}
                    // aria-checked={showBankAccount}
                    onClick={() => setShowBankAccount(!showBankAccount)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setShowBankAccount(!showBankAccount)
                      }
                    }}
                    edge="end"
                    onMouseDown={handleMouseDownPassword}
                  >
                    {/* {!showBankAccount ? (
                          <img src={VisibilityOffIcon} />
                        ) : (
                          <img src={VisibilityIcon} />
                        )} */}
                    {!showBankAccount ? (
                      <span aria-label="hide account Number" id="eye-toggle"><img src={VisibilityOffIcon} alt="" /></span>
                    ) : (
                      <span aria-label="show account Number" id="eye-toggle"> <img src={VisibilityIcon} alt="" /></span>
                    )}
                  </IconButton>
                </InputAdornment>
              }
              inputProps={{
                "aria-invalid":
                  errors && Object.keys(errors).includes("bankAccountNumber") ? "true" : "false",
                "aria-required": true,
              }}
              onKeyPress={(e: any) => {
                if (!/[0-9A-Za-z]/.test(e.key)) {
                  e.preventDefault();
                }
                if (e.target.value.length > "16") {
                  e.preventDefault();
                  return false;
                }
              }}
              className={
                errorsBankAccountDetails?.bankAccountNumber
                  ? "inputErrorBorder"
                  : ""
              }
              onBlur={(e: any) => {
                if (watchBank('bankAccountNumber') === null || watchBank('bankAccountNumber') !== null) {
                  triggerBankDetails('bankAccountNumber');
                }
                if (watchBank('bankAccountNumber') !== null && watchBank('confirmBankAccountNumber') !== null) {
                  triggerBankDetails('bankAccountNumber');
                  triggerBankDetails('confirmBankAccountNumber');
                }
              }}
            />

            <ErrorMessage
              errors={errorsBankAccountDetails}
              name="bankAccountNumber"
              render={({ message }) => (
                <Box className="errorMsgFormat" id="bankAccountNumber-error" >
                  <span className="inputFiledErrorImg"></span>
                  <span className="inputFiledErrorMsg">{message}</span>
                </Box>
              )}
            />
          </FormControl>

          <FormControl
            className="creditCardInput"
            variant="standard"
            sx={{ width: "100%", my: 1 }}
          >
            <InputLabel
              sx={inputLabelCss}
              shrink
              htmlFor="confirmBankAccountNumber"
            >
              {PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.confirmbankAccountNoLabel}
            </InputLabel>

            <BootstrapInput
              defaultValue=""
              id="confirmBankAccountNumber"
              aria-describedby="confirmBankAccountNumber-error"
              {...registerBankAccount("confirmBankAccountNumber")}
              placeholder={PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.confirmbankAccountNoPlaceholder}
              autoComplete="new-password"
              type={showBankAccountConfirm ? "text" : "password"}
              endAdornment={
                <InputAdornment
                  position="end"
                  className="eyeToggleBtnWrap"
                  sx={{
                    padding: "0px",
                    position: "absolute",
                  }}
                >
                  <IconButton
                    className="togglePwdVisiblebtn"
                    aria-label="account Number"
                    // role="switch"                       
                    aria-describedby="eye-toggle-icon"
                    aria-pressed={showBankAccountConfirm}
                    // aria-checked={showBankAccountConfirm}
                    onClick={() =>
                      setShowBankAccountConfirm(!showBankAccountConfirm)
                    }
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setShowBankAccountConfirm(!showBankAccountConfirm)
                      }
                    }}
                    edge="end"
                    onMouseDown={handleMouseDownPassword}
                  >
                    {/* {!showBankAccountConfirm ? (
                          <img src={VisibilityOffIcon} />
                        ) : (
                          <img src={VisibilityIcon} />
                        )} */}
                    {!showBankAccountConfirm ? (
                      <span aria-label="hide account Number" id="eye-toggle-icon"><img src={VisibilityOffIcon} alt="" /></span>
                    ) : (
                      <span aria-label="show account Number" id="eye-toggle-icon"> <img src={VisibilityIcon} alt="" /></span>
                    )}
                  </IconButton>
                </InputAdornment>
              }
              inputProps={{
                "aria-invalid":
                  errors && Object.keys(errors).includes("confirmBankAccountNumber") ? "true" : "false",
                "aria-required": true,
              }}
              onKeyPress={(e: any) => {
                if (!/[0-9A-Za-z]/.test(e.key)) {
                  e.preventDefault();
                }
                if (e.target.value.length > "16") {
                  e.preventDefault();
                  return false;
                }
              }}
              className={
                errorsBankAccountDetails?.confirmBankAccountNumber
                  ? "inputErrorBorder"
                  : ""
              }
              onBlur={(e: any) => {
                triggerBankDetails('confirmBankAccountNumber');
              }}
            />
            <ErrorMessage
              errors={errorsBankAccountDetails}
              name="confirmBankAccountNumber"
              render={({ message }) => (
                <Box className="errorMsgFormat" id="confirmBankAccountNumber-error">
                  <span className="inputFiledErrorImg"></span>
                  <span className="inputFiledErrorMsg">{message}</span>
                </Box>
              )}
            />
          </FormControl>
        </Box>

        {isAutoPay && ( /**Only for Autopay */
          <Typography component="span" className="checkBox primarycheckbox">
            <label className="checkboxMain makePrimaryPaymentCheckbox">
              <input
                type="checkbox"
                checked={watchBank("isPrimaryPaymentMethod")}
                aria-checked={watchBank("isPrimaryPaymentMethod")}
                onChange={(event) =>
                  setValueForBank(
                    "isPrimaryPaymentMethod",
                    event.target.checked
                  )
                }
                className="radioInput"
                readOnly={!defaultPaymentMethodId ||  defaultPaymentMethodId === bank?.id && fromEditCard}
                disabled={!defaultPaymentMethodId || defaultPaymentMethodId === bank?.id && fromEditCard}
              />
              {QBP_ON
                ? `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.saveCardForFurthurUse}`
                : `${PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.makePrimaryMethodCheckboxLabel}`}
              <span className="checkBoxLabel"></span>
            </label>
          </Typography>
        )}
        {/* </>
        )} */}
      </Box>

      {/* {(!QBP_ON || isAutoPay) && ( */}
      {(showTC) && (
        <Box>
          <Typography
            variant="body2"
            id="chkTermsAndCondition"
            color="initial"
            className="BeforeContinueSms"
          >
            {
              ["CTL", "CENTURY LINK"].includes(companyName.toUpperCase())
                ? QBP_FLOW_SELECT_PAYMENT?.payment_descriptions?.terms_and_conditions
                : "Before continuing, please review the Terms and Conditions of our payment processor (ACI Speedpay) and, if acceptable, check the box below."
            }
          </Typography>

          <FormControl variant="standard">
            <Typography component="div" className="checkBox termsCheckbox">
              <label className="checkboxMain">
                <input
                  type="checkbox"
                  className="radioInput"
                  id="isTermsAndCondition"
                  {...registerBankAccount("isTermsAndCondition")}
                  checked={watchBank("isTermsAndCondition")}
                  aria-checked={watchBank("isTermsAndCondition")}
                  aria-required={watchBank("isTermsAndCondition")}
                  aria-describedby="terms chkTermsAndCondition"


                  onChange={(event) => (
                    setValueForBank(
                      "isTermsAndCondition",
                      event.target.checked
                    ),
                    triggerBankDetails("isTermsAndCondition")
                  )}

                />
                <Typography component="span">{PAYMENT_METHOD_CREDIT_MANAGE_AUTOPAY_SECTION?.terms_condi_agree}</Typography>
                <Typography
                  component="a"
                  href={
                    (companyName &&
                      ["CTL", "CENTURY LINK"].includes(companyName.toUpperCase())) ||
                      (user?.billingType &&
                        (user?.billingType?.toUpperCase() === "POSTPAID"))
                      ? "https://www.speedpay.com/terms/"
                      : "https://www.brightspeed.com/aboutus/legal/consumer/payment-agreement"

                  }
                  target="_blank"
                  aria-label="Terms and Conditions opens in new tab"
                >
                  {QBP_FLOW_SELECT_PAYMENT?.payment_descriptions?.termsconditionsLabel}
                </Typography>.*
                <span
                  className={
                    Object.keys(errorsBankAccountDetails).length !== 0 &&
                      Object.keys(errorsBankAccountDetails)?.includes(
                        "isTermsAndCondition"
                      )
                      ? "showErrorBorder_new checkBoxLabel"
                      : "checkBoxLabel"
                  }
                ></span>
              </label>
            </Typography>

            <ErrorMessage
              errors={errorsBankAccountDetails}
              name="isTermsAndCondition"
              render={({ message }) => (
                <Box className="errorMsgFormat" id="terms">
                  <span className="inputFiledErrorImg"></span>
                  <span className="inputFiledErrorMsg">{message}</span>
                </Box>
              )}
            />
          </FormControl>
        </Box>
      )}

      <Box className="required-lbl">
        <Typography component="p" className="requiredCheckMark">
          <span className="requiredCheckMark">
            {QBP_FLOW?.required_label}
          </span>
        </Typography>
      </Box>

      <Box className="payment-overlay-cta">
        <Button
          variant="outlined"
          className="cancel-button"
          color="primary"
          onClick={() => {
            addEneventGTM(
              PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cancelButtonLabel,
              sessionId,
              user.billingAccountNumber,
              companyName
            );

            unAuthQbp
              ? DwLogutil({
                ...dwLogDefaults,
                stepName: unauthqbp_cancel_step1
              })

              : (isAutoPay) ? DwLogutil({ ...dwLogDefaults, stepName: (fromEditCard) ? AP_edit_PM_bank_cancel_cta : AP_add_PM_bank_cancel_cta }) : DwLogutil({
                ...dwLogDefaults,
                stepName: qbp_cancel_form
              });

            onClose();
          }}
        >
          {QBP_FLOW_SELECT_PAYMENT?.buttons_labels?.cancel}
        </Button>
        <Button
          variant="contained"
          color="primary"
          className="continue-button"
          onClick={handleSubmitBankAccount(onSubmitBankDetails)}
          disabled={(isEditFormTidy || isUnAUthQbpFormTidy || isUnAUthPaFormTidy)}
        >
          {unAuthQbp ? QBP_FLOW_SELECT_PAYMENT?.buttons_labels?.next : QBP_FLOW_SELECT_PAYMENT?.buttons_labels?.continue}
        </Button>
      </Box>

      <Backdrop
        className="custom-loader-backdrop"
        sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 2 }}
        open={isSubmitLoader}
      >
        <div className="custom-loader"></div>
      </Backdrop>

        <Box className="new-close-icon-cantainer">
          <Typography component="button"
            className="buttonText"
            aria-label="Close the dialog"
            onClick={() => {
              addEneventGTM(
                fromEditCard
                  ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cancelButtonLabel
                  : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cancelButtonLabel,
                sessionId,
                user.billingAccountNumber
              );
              const stepName = unAuthQbp ? qbp_cancel_form : isUnAuthPa ? EC_DW_LOGGING_STEPS.Pa_cancel_form : (isAutoPay) ? (fromEditCard) ? AP_edit_PM_bank_cancel_cta : AP_add_PM_bank_cancel_cta : ""
              DwLogutil({
                ...dwLogDefaults,
                stepName
              });
              addEneventGTM(
                stepName,
                sessionId,
                user?.billingAccountNumber,
                companyName
              );
              onClose();
            }}>
            <img
              src={close}
              alt="Close the dialog"

            />
          </Typography>
        </Box>
    </Box>
  );
};

export default AddPaymentMethodBank;

